class ComplementaryProducts extends window.PURELEI.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 1000)
  }

  render () {
    if (!this.dataset.productId) return

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector(
          'complementary-products-carousel',
        )
        const hasItems =
          recommendations && recommendations.outerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('complementary-products')
            .forEach((container) => {
              container.innerHTML = recommendations.outerHTML
            })
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', ComplementaryProducts)
}
